import { Component, Inject, OnInit } from '@angular/core';
import {  Invoice,  InvoiceModule,} from '../../appshared/invoice/invoice/invoice.module';
import { ToastrService } from 'ngx-toastr';
import { CartService } from '../../appshared/invoice/cart.service';
import {  MAT_DIALOG_DATA,  MatDialog,  MatDialogModule,  MatDialogRef,} from '@angular/material/dialog';
import { PromotionCodeService } from '../../appshared/invoice/promotion-code/promotion-code.service';
import { InvoiceElementsService } from '../../appshared/invoice/invoice-elements/invoice-elements.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DeliveryAddressService } from '../../appshared/invoice/delivery-address/delivery-address.service';
import { InvoiceService } from '../../appshared/invoice/invoice/invoice.service';
import { DeliveryAddressModule } from '../../appshared/invoice/delivery-address/delivery-address.module';
import {  InvoiceElements,} from '../../appshared/invoice/invoice-elements/invoice-elements.module';
import { InsertOTPDialogComponent } from '../../shared/insert-otpdialog/insert-otpdialog.component';
import { AccountingTreeModule } from '../../appshared/accounting/accounting-tree/accounting-tree.module';
import { AccountingTreeService } from '../../appshared/accounting/accounting-tree/accounting-tree.service';
import { ItemService } from '../../appshared/invoice/item/item.service';
import { AppLoaderService } from '../../services/app-loader/app-loader.service';
import { CommonModule, NgFor } from '@angular/common';
import {
  CountryISO,
  SearchCountryField,
  PhoneNumberFormat,
  NgxIntlTelInputModule
} from 'ngx-intl-tel-input';

import { FooterComponent } from '../../shared/footer/footer.component';
import { HeaderComponent } from '../../shared/header/header.component';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { LocalStoreService } from '../../services/local-store.service';
import { RouterLink } from '@angular/router';
import {
  faHeart,
  faSearch,
  faShoppingBag,
  faUserCircle,
  faCoffee,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { StyleDirectionService } from '../../services/style-direction.service';
import { Direction } from '@angular/cdk/bidi';



@Component({
  selector: 'app-checkout',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatDialogModule,
    CommonModule,
    FontAwesomeModule,
    NgFor,
    TranslateModule,
    FooterComponent,
    HeaderComponent,
    FormsModule,
    RouterLink,
    BsDropdownModule,
    NgxIntlTelInputModule
  ],
  providers: [{ provide: MAT_DIALOG_DATA, useValue: {} }],
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.css'],
})

export class CheckoutComponent implements OnInit {
  bsValue = new Date();
  maxDate = new Date();
  minDate = new Date();
  Direction: Direction = "ltr";

  products: any[] = [];
  total: number = 0;
  dir: Direction = localStorage.getItem('locale') == 'ar' ? "rtl" : "ltr";

  public IsServicesTerms: boolean = false;
  faSearch = faSearch;

  ComID: number = 1;
  discount: number = 0;
  isDifferentRecipient: boolean = false;
  isDisabledVoucher: boolean = false;
  mainForm: InvoiceModule = new InvoiceModule();
  public SelectedLanguage: string = 'en';
  constructor(
    private toastr: ToastrService,
    private cartService: CartService,
    public servItem: ItemService,
    private loader: AppLoaderService,
    public dialog: MatDialog,
    private styleDirectionService: StyleDirectionService,
    private accountService: AccountingTreeService,
    private servPromotionCode: PromotionCodeService,
    private servInvoiceElements: InvoiceElementsService,
    public translate: TranslateService,
    public servDeliveryAddress: DeliveryAddressService,
    public servInvoice: InvoiceService,
    private ls: LocalStoreService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (this.translate.currentLang != undefined) {
      this.SelectedLanguage = this.translate.currentLang;
    }
    this.maxDate.setDate(this.maxDate.getDate() + 40);
    this.setDirectionAndStyles(this.SelectedLanguage);
  }

  CountryISO = CountryISO;
  SearchCountryField = SearchCountryField;
  PhoneNumberFormat = PhoneNumberFormat; // ✅ Add this line

  phoneNumber: any;
  separateDialCode = true;

  //, CountryISO.UnitedArabEmirates
  preferredCountries: CountryISO[] = [CountryISO.Oman];
  gulfCountries: CountryISO[] = [
    CountryISO.Oman,
    CountryISO.UnitedArabEmirates,
    CountryISO.SaudiArabia,
    CountryISO.Kuwait,
    CountryISO.Bahrain,
    CountryISO.Qatar
  ];

  phoneForm = new FormGroup({
    phone: new FormControl({}, [Validators.required])
  });

  onCountryChange(event: any) {
    this.Dialing = event.dialCode;
    //console.log('Country changed:', event);
  }

  //checkNumber() {
  //  console.log('Phone number changed:', this.phoneNumber);
  //}


  setDirectionAndStyles(storedLang: string) {
    if (storedLang === 'ar') {
      this.Direction = 'rtl';
      this.styleDirectionService.fillData(true);
    } else {
      this.Direction = 'ltr';
      this.styleDirectionService.fillData(false);
    }
  }



  ngOnInit(): void {

    this.initializeCart();
    this.initializeCheckoutData();

    this.mainForm.deliveryMethod = 'Receive from Store';
    this.products = this.cartService.getItems();

    this.total = +this.cartService.getTotal();

    this.mainForm.mgCompanyID = this.ComID;
    this.mainForm.mgBranchID = 1;
    this.mainForm.mgBranchStockID = 1;
    this.mainForm.acYearID = 1;
    this.mainForm.sellerID = 3848;
    this.mainForm.type = 'Cash';
    this.mainForm.invoiceType = 'Draft E-Sale';
    this.mainForm.statusType = 'Approved';
    this.mainForm.invoiceTypeAr = 'مسودة مبيعات إلكترونية';

    this.mainForm.totalTax = 0;
    this.mainForm.serviceCharge = 0;
    this.countTotal();
  }

  private initializeCart(): void {
    // Get items from localStorage
    const storedItems = this.ls.getItem('CartItems');

    if (storedItems && Array.isArray(storedItems) && storedItems.length > 0) {
      // Update the cart service with stored items
      this.cartService.setItemsData(storedItems);
      // Get the items for the component
      this.products = this.cartService.getItems();
      this.total = +this.cartService.getTotal();
    } else {
      // Handle empty cart
      this.handleEmptyCart();
    }
  }

  private handleEmptyCart(): void {
    const message = this.translate.instant('Cart_is_empty');
    this.toastr.warning(message);
    // Redirect to cart page
    window.location.href = '/cart'; // Or use Router if available
  }

  private initializeCheckoutData(): void {
    // Only initialize if we have products
    if (!this.products || this.products.length === 0) {
      return;
    }
  }

  onSenderChange() {
    if (!this.isDifferentRecipient) {
      this.mainForm.receiveName = this.mainForm.clientName;
      this.mainForm.receivePhoneNo = this.mainForm.phoneNO;
    }
  }

  onDifferentRecipientChange() {
    if (!this.isDifferentRecipient) {
      this.mainForm.receiveName = this.mainForm.clientName;
      this.mainForm.receivePhoneNo = this.mainForm.phoneNO;
    } else {
      this.mainForm.receiveName = '';
      this.mainForm.receivePhoneNo = '';
    }
  }

  countTotal() {
    var vat = 0;
    this.discount = 0;
    var total = 0;
    for (var i = 0; i < this.products.length; i++) {
      var fromDate = new Date(this.products[i].webDiscountFromDate);
      var toDate = new Date(this.products[i].webDiscountToDate);
      var dateNow = new Date();

      var price = this.products[i].salesPrice;
      if (
        this.products[i].activateWebDiscount &&
        fromDate < dateNow &&
        toDate > dateNow
      ) {
        price = this.products[i].webDiscountAmount;
      }

      var itemTotal = this.products[i].cartQuantity * price;

      var itemDiscount = 0;
      if (this.mainForm.percentage != '' && this.mainForm.percentage != '0') {
        itemDiscount += (+this.mainForm.percentage! / 100) * itemTotal;
      }

      this.discount += itemDiscount;

      itemTotal = itemTotal - itemDiscount;

      var ItemVAT = (this.products[i].saleTaxPercentage / 100) * itemTotal;

      vat += ItemVAT;
      total += +(itemTotal + ItemVAT).toFixed(3);
    }

    this.total = total;

    this.mainForm.totalTax = vat;
    this.mainForm.amount = total + this.mainForm.serviceCharge!;
  
  }

  ///////////////////////////////////////////////////////////////////////////
  Dialing: string = '968';





  /////////////////////////////////////////



  onDeliveryMethod() {
    if (this.mainForm.deliveryMethod == 'Receive from Store') {
      this.mainForm.serviceCharge = 0;
      this.countTotal();

      this.isAddressDelivery1 = false;
      this.isAddressDelivery2 = false;
      this.isAddressDelivery3 = false;
      this.isAddressDelivery4 = false;
      this.isAddressDelivery5 = false;

      this.addressDeliveryValue1 = 0;
      this.addressDeliveryValue2 = 0;
      this.addressDeliveryValue3 = 0;
      this.addressDeliveryValue4 = 0;
      this.addressDeliveryValue5 = 0;

      this.addressDeliveryName1 = '';
      this.addressDeliveryName2 = '';
      this.addressDeliveryName3 = '';
      this.addressDeliveryName4 = '';
      this.addressDeliveryName5 = '';

      this.addressDeliveryData1 = [];
      this.addressDeliveryData2 = [];
      this.addressDeliveryData3 = [];
      this.addressDeliveryData4 = [];
      this.addressDeliveryData5 = [];
    } else {
      this.servDeliveryAddress.getServiceParentID(this.ComID, 0).subscribe(
        (res) => {

          this.addressDeliveryData1 = res as DeliveryAddressModule[];
          if (this.mainForm.deliveryMethod == 'Receive from Delivery Company') {

            for (let i = this.addressDeliveryData1.length - 1; i >= 0; i--) {
              if (this.addressDeliveryData1[i].inDeliveryAddressID != 120) {
                this.addressDeliveryData1.splice(i, 1);
              }
            }

          }
          else {
            for (let i = this.addressDeliveryData1.length - 1; i >= 0; i--) {
              if (this.addressDeliveryData1[i].inDeliveryAddressID == 120) {
                this.addressDeliveryData1.splice(i, 1);
              }
            }
          }


          this.mainForm.inDeliveryAddressID =
            this.addressDeliveryData1[0].inDeliveryAddressID;
          this.addressDeliveryValue1 =
            this.addressDeliveryData1[0].inDeliveryAddressID;
          this.addressDeliveryName1 = this.addressDeliveryName(
            this.addressDeliveryData1[0].type!
          );
          this.isAddressDelivery1 = true;
          this.mainForm.serviceCharge =
            this.addressDeliveryData1[0].serviceCharges;
          this.countTotal();
          this.onAddressDelivery1();
        },
        (err) => {
          this.mainForm.inDeliveryAddressID = 0;
          this.isAddressDelivery1 = false;

          this.addressDeliveryValue1 = 0;
          this.addressDeliveryValue2 = 0;
          this.addressDeliveryValue3 = 0;
          this.addressDeliveryValue4 = 0;
          this.addressDeliveryValue5 = 0;

          this.addressDeliveryName1 = '';
          this.addressDeliveryName2 = '';
          this.addressDeliveryName3 = '';
          this.addressDeliveryName4 = '';
          this.addressDeliveryName5 = '';

          this.addressDeliveryData1 = [];
          this.addressDeliveryData2 = [];
          this.addressDeliveryData3 = [];
          this.addressDeliveryData4 = [];
          this.addressDeliveryData5 = [];
        }
      );
    }
  }

  onAddressDelivery1() {
    this.servDeliveryAddress
      .getServiceParentID(this.ComID, this.addressDeliveryValue1)
      .subscribe(
        (res) => {
          this.addressDeliveryData2 = res as DeliveryAddressModule[];

          this.mainForm.inDeliveryAddressID =
            this.addressDeliveryData2[0].inDeliveryAddressID;
          this.addressDeliveryValue2 =
            this.addressDeliveryData2[0].inDeliveryAddressID;
          this.addressDeliveryName2 = this.addressDeliveryName(
            this.addressDeliveryData2[0].type!
          );
          this.mainForm.serviceCharge = this.addressDeliveryData2[0].serviceCharges;
          this.mainForm.deliveryAddressTXTEn = this.addressDeliveryData2[0].nameEn;
          this.mainForm.deliveryAddressTXTAr = this.addressDeliveryData2[0].nameAr;

          this.countTotal();
          this.isAddressDelivery2 = true;
          this.onAddressDelivery2();
        },
        (err) => {
          this.mainForm.inDeliveryAddressID = this.addressDeliveryValue1;

          for (var i = 0; i < this.addressDeliveryData1!.length; i++) {
            if (
              this.addressDeliveryData1![i].inDeliveryAddressID ==
              this.mainForm.inDeliveryAddressID
            ) {
              if (this.addressDeliveryData1![i].freeDeliveryFromAmount != 0) {
                if (
                  this.addressDeliveryData2![i].freeDeliveryFromAmount! <
                  this.mainForm.amount!
                ) {
                  this.mainForm.serviceCharge =
                    this.addressDeliveryData1![i].serviceCharges;

                  this.mainForm.deliveryAddressTXTEn = this.addressDeliveryData1![i].nameEn;
                  this.mainForm.deliveryAddressTXTAr = this.addressDeliveryData1![i].nameAr;
                  this.countTotal();
                }
              }
            }
          }

          this.isAddressDelivery2 = false;
          this.isAddressDelivery3 = false;
          this.isAddressDelivery4 = false;
          this.isAddressDelivery5 = false;

          this.addressDeliveryValue3 = 0;
          this.addressDeliveryValue4 = 0;
          this.addressDeliveryValue5 = 0;

          this.addressDeliveryName3 = '';
          this.addressDeliveryName4 = '';
          this.addressDeliveryName5 = '';

          this.addressDeliveryData3 = [];
          this.addressDeliveryData4 = [];
          this.addressDeliveryData5 = [];
        }
      );
  }

  onAddressDelivery2() {
    this.servDeliveryAddress
      .getServiceParentID(this.ComID, this.addressDeliveryValue2)
      .subscribe(
        (res) => {
          this.addressDeliveryData3 = res as DeliveryAddressModule[];

          this.mainForm.inDeliveryAddressID =
            this.addressDeliveryData3[0].inDeliveryAddressID;
          this.addressDeliveryValue3 =
            this.addressDeliveryData3[0].inDeliveryAddressID;
          this.addressDeliveryName3 = this.addressDeliveryName(
            this.addressDeliveryData3[0].type!
          );
          this.mainForm.serviceCharge =
            this.addressDeliveryData3[0].serviceCharges;
          this.mainForm.deliveryAddressTXTEn = this.addressDeliveryData3[0].nameEn;
          this.mainForm.deliveryAddressTXTAr = this.addressDeliveryData3[0].nameAr;
          this.countTotal();
          this.isAddressDelivery3 = true;
          this.onAddressDelivery3();
        },
        (err) => {
          this.mainForm.inDeliveryAddressID = this.addressDeliveryValue2;

          for (var i = 0; i < this.addressDeliveryData2!.length; i++) {
            if (
              this.addressDeliveryData2![i].inDeliveryAddressID ==
              this.mainForm.inDeliveryAddressID
            ) {
              if (this.addressDeliveryData2![i].freeDeliveryFromAmount != 0) {
                if (
                  this.addressDeliveryData2![i].freeDeliveryFromAmount! <
                  this.mainForm.amount!
                ) {
                  this.mainForm.serviceCharge =
                    this.addressDeliveryData2![i].serviceCharges;
                  this.mainForm.deliveryAddressTXTEn = this.addressDeliveryData2![0].nameEn;
                  this.mainForm.deliveryAddressTXTAr = this.addressDeliveryData2![0].nameAr;
                  this.countTotal();
                }
              }
            }
          }

          this.isAddressDelivery3 = false;
          this.isAddressDelivery4 = false;
          this.isAddressDelivery5 = false;

          this.addressDeliveryValue4 = 0;
          this.addressDeliveryValue5 = 0;

          this.addressDeliveryName4 = '';
          this.addressDeliveryName5 = '';

          this.addressDeliveryData4 = [];
          this.addressDeliveryData5 = [];
        }
      );
  }

  onAddressDelivery3() {
    this.servDeliveryAddress
      .getServiceParentID(this.ComID, this.addressDeliveryValue3)
      .subscribe(
        (res) => {
          this.addressDeliveryData4 = res as DeliveryAddressModule[];

          this.mainForm.inDeliveryAddressID =
            this.addressDeliveryData4[0].inDeliveryAddressID;
          this.addressDeliveryValue4 =
            this.addressDeliveryData4[0].inDeliveryAddressID;
          this.addressDeliveryName4 = this.addressDeliveryName(
            this.addressDeliveryData4[0].type!
          );
          this.mainForm.serviceCharge =
            this.addressDeliveryData4[0].serviceCharges;
          this.mainForm.deliveryAddressTXTEn = this.addressDeliveryData4[0].nameEn;
          this.mainForm.deliveryAddressTXTAr = this.addressDeliveryData4[0].nameAr;
          this.countTotal();
          this.isAddressDelivery4 = true;
          this.onAddressDelivery4();
        },
        (err) => {
          this.mainForm.inDeliveryAddressID = this.addressDeliveryValue3;

          for (var i = 0; i < this.addressDeliveryData3!.length; i++) {
            if (
              this.addressDeliveryData3![i].inDeliveryAddressID ==
              this.mainForm.inDeliveryAddressID
            ) {
              if (this.addressDeliveryData3![i].freeDeliveryFromAmount != 0) {
                if (
                  this.addressDeliveryData3![i].freeDeliveryFromAmount! <
                  this.mainForm.amount!
                ) {
                  this.mainForm.serviceCharge =
                    this.addressDeliveryData3![i].serviceCharges;
                  this.mainForm.deliveryAddressTXTEn = this.addressDeliveryData3![0].nameEn;
                  this.mainForm.deliveryAddressTXTAr = this.addressDeliveryData3![0].nameAr;
                  this.countTotal();
                }
              }
            }
          }

          this.isAddressDelivery4 = false;
          this.isAddressDelivery5 = false;

          this.addressDeliveryValue4 = 0;
          this.addressDeliveryValue5 = 0;

          this.addressDeliveryName4 = '';
          this.addressDeliveryName5 = '';

          this.addressDeliveryData4 = [];
          this.addressDeliveryData5 = [];
        }
      );
  }

  onAddressDelivery4() {
    this.servDeliveryAddress
      .getServiceParentID(this.ComID, this.addressDeliveryValue4)
      .subscribe(
        (res) => {
          this.addressDeliveryData5 = res as DeliveryAddressModule[];

          this.mainForm.inDeliveryAddressID =
            this.addressDeliveryData5[0].inDeliveryAddressID;
          this.addressDeliveryValue5 =
            this.addressDeliveryData5[0].inDeliveryAddressID;
          this.addressDeliveryName5 = this.addressDeliveryName(
            this.addressDeliveryData5[0].type!
          );
          this.mainForm.serviceCharge =
            this.addressDeliveryData5[0].serviceCharges;
          this.mainForm.deliveryAddressTXTEn = this.addressDeliveryData5[0].nameEn;
          this.mainForm.deliveryAddressTXTAr = this.addressDeliveryData5[0].nameAr;
          this.countTotal();
          this.isAddressDelivery5 = true;
          this.onAddressDelivery5();
        },
        (err) => {
          this.mainForm.inDeliveryAddressID = this.addressDeliveryValue4;

          for (var i = 0; i < this.addressDeliveryData4!.length; i++) {
            if (
              this.addressDeliveryData4![i].inDeliveryAddressID ==
              this.mainForm.inDeliveryAddressID
            ) {
              if (this.addressDeliveryData4![i].freeDeliveryFromAmount != 0) {
                if (
                  this.addressDeliveryData4![i].freeDeliveryFromAmount! <
                  this.mainForm.amount!
                ) {
                  this.mainForm.serviceCharge =
                    this.addressDeliveryData4![i].serviceCharges;
                  this.mainForm.deliveryAddressTXTEn = this.addressDeliveryData4![0].nameEn;
                  this.mainForm.deliveryAddressTXTAr = this.addressDeliveryData4![0].nameAr;
                  this.countTotal();
                }
              }
            }
          }

          this.isAddressDelivery5 = false;

          this.addressDeliveryValue5 = 0;

          this.addressDeliveryName5 = '';

          this.addressDeliveryData5 = [];
        }
      );
  }

  onAddressDelivery5() {
    this.mainForm.inDeliveryAddressID = this.addressDeliveryValue5;

    for (var i = 0; i < this.addressDeliveryData5!.length; i++) {
      if (
        this.addressDeliveryData5![i].inDeliveryAddressID ==
        this.mainForm.inDeliveryAddressID
      ) {
        if (this.addressDeliveryData5![i].freeDeliveryFromAmount != 0) {
          if (
            this.addressDeliveryData5![i].freeDeliveryFromAmount! <
            this.mainForm.amount!
          ) {
            this.mainForm.serviceCharge =
              this.addressDeliveryData5![i].serviceCharges;
            this.mainForm.deliveryAddressTXTEn = this.addressDeliveryData5![0].nameEn;
            this.mainForm.deliveryAddressTXTAr = this.addressDeliveryData5![0].nameAr;
            this.countTotal();
          }
        }
      }
    }
  }

  onPromotionCode() {
    if (this.mainForm.promotionCode != '') {
      this.loader.open();

      this.servPromotionCode
        .getServiceCode(this.ComID, this.mainForm.promotionCode!)
        .subscribe(
          (res) => {
            this.loader.close();
            if (res == '0') {
              var transR = this.translate.instant('Not_Available');
              this.toastr.warning(transR, '');
            } else {
              var splitted = res.split('-', 2);

              this.mainForm.percentage = splitted[0];

              this.countTotal();

              var transR = this.translate.instant('Added_Successfully');
              this.toastr.success(transR, '');
              this.isDisabledVoucher = true;
            }
          },
          (err) => {
            this.loader.close();
          }
        );
    }
  }

  addressDeliveryName(addressDN: string) {
    if (this.SelectedLanguage == 'ar') {
      if (addressDN == 'None') {
        addressDN = 'غير محدد';
      } else if (addressDN == 'Country') {
        addressDN = 'الدولة';
      } else if (addressDN == 'Governorate') {
        addressDN = 'المحافظة';
      } else if (addressDN == 'Wilayat') {
        addressDN = 'الولاية';
      } else if (addressDN == 'Village') {
        addressDN = 'القرية';
      } else if (addressDN == 'City') {
        addressDN = 'المدينة';
      } else if (addressDN == 'Delivery Method') {
        addressDN = 'طريقة التوصيل';
      }
    }

    return addressDN;
  }

  isAddressDelivery1: boolean = false;
  isAddressDelivery2: boolean = false;
  isAddressDelivery3: boolean = false;
  isAddressDelivery4: boolean = false;
  isAddressDelivery5: boolean = false;

  addressDeliveryName1: string = '';
  addressDeliveryName2: string = '';
  addressDeliveryName3: string = '';
  addressDeliveryName4: string = '';
  addressDeliveryName5: string = '';

  addressDeliveryValue1: number = 0;
  addressDeliveryValue2: number = 0;
  addressDeliveryValue3: number = 0;
  addressDeliveryValue4: number = 0;
  addressDeliveryValue5: number = 0;
  public addressDeliveryData1: DeliveryAddressModule[] | undefined;
  public addressDeliveryData2: DeliveryAddressModule[] | undefined;
  public addressDeliveryData3: DeliveryAddressModule[] | undefined;
  public addressDeliveryData4: DeliveryAddressModule[] | undefined;
  public addressDeliveryData5: DeliveryAddressModule[] | undefined;

  onOrder(IsTerms: boolean) {
  

    var phone: any;
    phone = this.phoneForm.get('phone')?.value;
    if (phone == null) {
      var transR = this.translate.instant('translations.Please_fill_the_required_fields');
      this.toastr.warning(transR, '');
      return;
    }
    this.mainForm.phoneNO = phone.number.replace(" ", "");
    this.mainForm.dialingCodes = phone.dialCode.replace("+", "");



   // this.mainForm.phoneNO = this.phoneForm.get('phone')?.value.toString();
    if (
      this.mainForm.amount == 0 ||
      this.mainForm.clientName == '' ||
      this.mainForm.phoneNO == '' ||
      this.mainForm.phoneNO == null ||
      //this.mainForm.receiveName == '' ||
      //this.mainForm.receivePhoneNo == '' ||
      IsTerms == false
    ) {
      var transR = this.translate.instant('translations.Please_fill_the_required_fields');
      this.toastr.warning(transR, '');
      return;
    } else {

      this.mainForm.receiveDialingCodes = '968';

      this.loader.open();
      this.servInvoice
        .getSendNotifyOTP(
          this.ComID,
          this.mainForm.phoneNO!,
          this.mainForm.dialingCodes!
        )
        .subscribe(
          (res) => {
            this.loader.close();
            if (res == 'success') {
              let title = 'add';
              let dialogRef: MatDialogRef<any> = this.dialog.open(
                InsertOTPDialogComponent,
                {
                  width: 'auto',
                  maxWidth: '90vw',
                  disableClose: true,
                  panelClass: 'centered-otp-dialog',
                  hasBackdrop: true,
                  data: {
                    title: title,
                    payload: '',
                    phoneNo: this.mainForm.phoneNO,
                    dialingCodes: this.mainForm.dialingCodes,
                  },
                }
              );
              dialogRef.afterClosed().subscribe((res) => {
                if (!res) {
                  return;
                }
                if (res == 'success') {
                  this.mainFormAccounting.mgCompanyID = 1;
                  this.mainFormAccounting.accountName = this.mainForm.clientName || '';
                  this.mainFormAccounting.nameAr = this.mainForm.clientName;
                  this.mainFormAccounting.phoneNo = this.mainForm.phoneNO;
                  this.mainFormAccounting.dialingCodes = this.mainForm.dialingCodes;
                  this.mainFormAccounting.parentID = 17;
                  this.mainFormAccounting.status = 'Active';
                  this.mainFormAccounting.clientType = 'Unlimited';
                  this.mainFormAccounting.type = 'Online Client';

                  this.loader.open();
                  this.accountService
                    .postService(this.mainFormAccounting)
                    .subscribe(
                      (res) => {
                        this.loader.close();
                        this.mainFormAccounting = res as AccountingTreeModule;

                        this.insertRecord();
                      },
                      (err) => {
                        this.loader.close();
                        var transR = this.translate.instant('Not_Available');
                        this.toastr.warning(transR, '');
                      }
                    );
                }
              });
            } else {
              var transR = this.translate.instant('Not_Available');
              this.toastr.warning(transR, '');
            }
          },
          (err) => {
            this.loader.close();
            var transR = this.translate.instant('Not_Available');
            this.toastr.warning(transR, '');
          }
        );
    }
  }

  public invoiceList: Invoice[] = [];
  public invoiceElementsList: InvoiceElements[] = [];
  public recordList: any = [];
  public policyList: any = [];
  public recordChequeList: any = [];
  public policyChequeList: any = [];
  public invoice2List: any[] = [];
  public invoiceElements2List: any[] = [];
  public DeleteInvoiceElementsSList: any[] = [];
  public invoiceListUpdate: any[] = [];
  public invoiceElementsListUpdate: any[] = [];

  mainFormAccounting: AccountingTreeModule = new AccountingTreeModule();

  insertRecord() {
    // Create Client ID
    this.mainForm.acAccountID = this.mainFormAccounting.acAccountID;
    this.mainForm.payingWay = 'Not Paid';
    this.mainForm.inInvoiceID = 0;
    this.mainForm.inInvoiceNo = 0;

    this.invoiceList = [];
    this.invoiceElementsList = [];
    this.recordList = [];
    this.policyList = [];
    this.recordChequeList = [];
    this.policyChequeList = [];
    this.invoice2List = [];
    this.invoiceElements2List = [];

    // console.log('MainForm before transfer:', this.mainForm);

    const invoice = this.servInvoice.transferInvoiceFromModule(this.mainForm);
    // console.log('Transformed Invoice:', invoice);
    this.invoiceList.push(invoice);

    // console.log('Products before transfer:', this.products);

    for (var i = 0; i < this.products.length; i++) {
      const element = this.servInvoiceElements.transferElementFromProduct(
        this.products[i]
      );
      // console.log(`Transformed Invoice Element ${i}:`, element);
      this.invoiceElementsList.push(element);
    }

    //   console.log('Final payload:', {
    //   invoiceList: this.invoiceList,
    //   invoiceElementsList: this.invoiceElementsList,
    // });

    this.loader.open();
    this.servInvoice
      .postMultiService(
        this.invoiceList,
        this.invoiceElementsList,
        this.recordList,
        this.policyList,
        this.recordChequeList,
        this.policyChequeList,
        this.invoice2List,
        this.invoiceElements2List,
        this.DeleteInvoiceElementsSList,
        this.invoiceListUpdate,
        this.invoiceElementsListUpdate
      )
      .subscribe({
        next: (res) => {
          this.loader.close();
          // console.log('API Response:', res);

          var ss = this.isNumber(res);

          if (ss) {
            var transR = this.translate.instant('Added_Successfully');
            this.toastr.success(transR, '');

            this.mainForm.inInvoiceID = +res;





            // Here Payment
            this.loader.open();

            this.servInvoice.getThawaniPayment(this.ComID, this.mainForm.inInvoiceID)
              .subscribe(res => {

                this.loader.close();


              }, err => {


                if (err.url != null && err.url != undefined) {

                  window.location.href = err.url;
                }
                else {
                  this.loader.close();
                  var transR = this.translate.instant('Not_Available');
                  this.toastr.warning(transR, '');
                }

              })


          }
          else {
            this.toastr.warning(res, 'Error');
          }
        },
        error: (err) => {
          this.loader.close();
          // console.log('API Error:', err);
          var transR = this.translate.instant('Error_Saving');
          this.toastr.error(transR, 'Error');
        },
      });
  }

  isNumber(value: string | number): boolean {
    return value != null && value !== '' && !isNaN(Number(value.toString()));
  }
}
